import BillReleaseForm from "./BillReleaseForm";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { useGetBillReleaseByIdQuery } from "./billReleaseApi";
import { skipToken } from "@reduxjs/toolkit/query";
import Preloader from "../../../components/common/Preloader";

const UpdateBillRelease = () => {

    let { billReleaseId } = useParams();
    const billReleaseByIdApi = useGetBillReleaseByIdQuery(billReleaseId ?? skipToken);

    const [crumbs, setCrumbs] = useState<any[]>([]);

    useEffect(() => {
        let billReleaseObj = billReleaseByIdApi?.data;
        if (billReleaseObj) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Bill Release", url: "/bill-release" },
            ]);

            document.title = "Bill Release";
        }
    }, [billReleaseByIdApi]);

    return (
        <>
            {billReleaseByIdApi.data === undefined || billReleaseByIdApi?.data?.id === undefined
                ? <Preloader />
                :
                <BillReleaseForm crumbs={crumbs} title={"Update Bill Release"} btnText={"Update"}
                    isReadOnly={hasPermission(["BILLREL-U"]) === false} />
            }
        </>
    )
}
export default UpdateBillRelease;